/* ai: перевод строк интерфейса. Ключ — русская строка ровно как в коде.
   Разделы на моках: AI-агенты, AI Assist, рассылки, подключение почты (интерфейс + демо-данные). */
const d: Record<string, string> = {
  // ── общее ──
  "Входящие": "Inbox",
  "Контакты": "Contacts",
  "Дашборд": "Dashboard",
  "Каналы": "Channels",
  "Жизненный цикл": "Lifecycle",
  "Рассылки": "Broadcasts",
  "Рабочие процессы": "Workflows",
  "Отчеты": "Reports",
  "Настройки": "Settings",
  "Начало работы": "Getting started",
  "Узнать больше": "Learn more",
  "Отмена": "Cancel",
  "Сохранить": "Save",
  "Создать": "Create",
  "Назад": "Back",
  "Понятно": "Got it",
  "Все": "All",
  "Вы": "You",
  "В": "V",
  "Сегодня": "Today",
  "Почта": "Email",
  "Телефон": "Phone",
  "Электронная почта": "Email",
  "Статус": "Status",
  "Автор": "Author",
  "Дата": "Date",
  "Название": "Name",
  "Получатели": "Recipients",
  "Метки": "Labels",
  "Шаблоны": "Templates",
  "Теги": "Tags",
  "Виджеты": "Widgets",
  "Доступы": "Access",
  "Демо-данные": "Demo data",
  "Демо-режим: смена тарифа здесь недоступна": "Demo mode: plan changes are not available here",
  "Раздел «{label}» в демо не открывается": "The “{label}” section does not open in the demo",
  "Пробный период Growth Plan закончится 3 ноября 2026 — через 6 дней. Обновите тариф, чтобы не потерять доступ.":
    "Your Growth Plan trial ends on 3 November 2026 — in 6 days. Upgrade to keep access.",
  "Чеклист онбординга": "Onboarding checklist",
  "Обновить тариф": "Upgrade plan",
  "Закрыть окно": "Close window",
  "Закрыть панель": "Close panel",
  "Очистить поиск": "Clear search",
  "Ещё действия": "More actions",

  // ── AI-агенты: интерфейс ──
  "Агенты ИИ": "AI agents",
  "AI-агенты": "AI agents",
  "рабочее пространство → агенты ИИ": "workspace → AI agents",
  "Активных агентов: {n}": "Active agents: {n}",
  "Создать AI-агента": "Create an AI agent",
  "Обзор": "Overview",
  "Шаблоны агентов": "Agent templates",
  "Мои агенты": "My agents",
  "Пока ни одного агента. Начните с шаблона или включите демо-данные внизу колонки.":
    "No agents yet. Start from a template or turn on demo data at the bottom of the column.",
  "Три агента работают с диалогами": "Three agents are handling conversations",
  "Включите, чтобы увидеть агентов с цифрами": "Turn on to see agents with stats",
  "Демо-режим: подробная справка по AI-агентам в макете недоступна": "Demo mode: detailed help on AI agents is not available in the mockup",
  "В демо уже работают три агента — откройте их в левой колонке.": "Three agents are already running in the demo — open them in the left column.",
  "Первый шаг — выбрать шаблон под задачу.": "The first step is to pick a template for your task.",
  "Использовать шаблон": "Use template",
  "Создать с нуля": "Create from scratch",
  "Соберите своего AI-агента под процессы компании.": "Build your own AI agent around your company’s processes.",
  "Начать с нуля": "Start from scratch",
  "Источники знаний": "Knowledge sources",
  "Агент отвечает по источникам знаний и шаблонам. Проверьте, что прайсы и регламенты загружены — иначе он передаст диалог человеку.":
    "The agent answers from knowledge sources and snippets. Make sure price lists and policies are uploaded — otherwise it will hand the conversation over to a person.",
  "включён": "enabled",
  "выключен": "disabled",
  "шаблон «{name}»": "template “{name}”",
  "Настроить": "Configure",
  "Включить агента": "Enable agent",
  "Диалогов": "Conversations",
  "Решено без человека": "Resolved without a human",
  "Передано людям": "Handed over to people",
  "Цель": "Goal",
  "Не задана": "Not set",
  "Инструкции": "Instructions",
  "Не заданы": "Not set",
  "Каналы и тон": "Channels and tone",
  "Каналы не выбраны": "No channels selected",
  "Тон: {tone}": "Tone: {tone}",
  "Передаёт диалог человеку, если не уверен в ответе": "Hands the conversation over to a person when unsure of the answer",
  "Отвечает сам до конца, без передачи человеку": "Answers on its own to the end, without handing over to a person",
  "Источники знаний агента": "Agent knowledge sources",
  "Всего агентов: {total} · диалогов обработано: {dialogs} · решено без человека: {resolved}. Демо-режим: данные живут только на этой странице.":
    "Total agents: {total} · conversations handled: {dialogs} · resolved without a human: {resolved}. Demo mode: data lives only on this page.",
  "Демо-режим: агенты и цифры живут только на этой странице и не сохраняются после перезагрузки.":
    "Demo mode: agents and stats live only on this page and are not saved after a reload.",
  "Агент «{name}» создан и включён — он готов принимать диалоги": "Agent “{name}” has been created and enabled — it is ready to take conversations",
  "Настройки агента «{name}» сохранены": "Settings for agent “{name}” saved",
  "Агент «{name}» выключен и больше не отвечает": "Agent “{name}” is disabled and no longer replies",
  "Агент «{name}» включён и снова принимает диалоги": "Agent “{name}” is enabled and taking conversations again",
  "Демо-данные включены: три агента уже работают с диалогами": "Demo data on: three agents are already handling conversations",
  "Демо-данные выключены — в рабочем пространстве снова нет агентов": "Demo data off — the workspace has no agents again",
  "Поля контакта": "Contact fields",
  "Конечно, курс включает живые занятия дважды в неделю.": "Of course, the course includes live classes twice a week.",
  "Агент отвечает сам и сам заполняет карточку клиента": "The agent replies on its own and fills in the customer card itself",

  // ── AI-агенты: панель ──
  "Свой агент": "Custom agent",
  "Новый AI-агент": "New AI agent",
  "Настройки агента": "Agent settings",
  "Шаблон «{name}»": "Template “{name}”",
  "Имя агента": "Agent name",
  "Например, Аня — приём обращений": "For example, Anya — intake",
  "Введите имя — от 2 символов": "Enter a name — at least 2 characters",
  "Цель агента": "Agent goal",
  "Что агент должен сделать в диалоге": "What the agent should achieve in a conversation",
  "Инструкции и правила": "Instructions and rules",
  "Как здороваться, что уточнять, когда передавать человеку": "How to greet, what to clarify, when to hand over to a person",
  "агент отвечает по источникам знаний": "the agent answers from knowledge sources",
  "Тон общения": "Tone of voice",
  "Передавать человеку": "Hand over to a person",
  "Если клиент просит сотрудника или ответа нет в источниках знаний.": "When the customer asks for a person or the answer is not in the knowledge sources.",
  "Агент отвечает только по источникам знаний и шаблонам рабочего пространства. Проверьте инструкции перед включением — он начнёт отвечать клиентам сразу.":
    "The agent answers only from the workspace knowledge sources and snippets. Review the instructions before enabling — it will start replying to customers right away.",
  "Создать агента": "Create agent",

  // ── AI-агенты: моки ──
  "Агенты искусственного интеллекта": "AI agents",
  "Обрабатывайте больше диалогов с меньшими усилиями, используя агентов искусственного интеллекта.": "Handle more conversations with less effort using AI agents.",
  "Расширьте свою команду с помощью агентов искусственного интеллекта.": "Extend your team with AI agents.",
  "Создан для обработки сотен диалогов одновременно.": "Built to handle hundreds of conversations at once.",
  "Начать": "Get started",
  "Мгновенные ответы на сообщения, круглосуточно, 7 дней в неделю.": "Instant replies to messages, 24/7.",
  "Автоматически обновляет этапы жизненного цикла и поля контактов.": "Automatically updates lifecycle stages and contact fields.",
  "Назначает диалоги другим агентам, командам и агентам ИИ.": "Assigns conversations to other agents, teams and AI agents.",
  "Отвечает на вопросы, используя источники знаний, и многое другое!": "Answers questions using knowledge sources, and much more!",
  "Сведения о контакте": "Contact details",
  "Шаблоны AI-агентов": "AI agent templates",
  "Используйте готового агента под задачу бизнеса — поддержка, продажи или приём заявок, — а можете собрать своего с нуля.":
    "Use a ready-made agent for your business task — support, sales or intake — or build your own from scratch.",
  "Администратор": "Receptionist",
  "Приём обращений": "Intake",
  "Приветствует клиентов, выясняет их потребности, фиксирует важные данные и аккуратно переводит диалог к нужному человеку или команде.":
    "Greets customers, finds out their needs, records key details and smoothly routes the conversation to the right person or team.",
  "Принять обращение, выяснить запрос и передать диалог нужному сотруднику.": "Take the enquiry, clarify the request and pass the conversation to the right employee.",
  "Здоровайтесь по имени клиента, уточните город и задачу, зафиксируйте телефон и почту. Если вопрос вне вашей компетенции — передайте диалог ответственному и предупредите клиента, что с ним свяжутся.":
    "Greet the customer by name, ask for their city and task, record phone and email. If the question is outside your scope, hand the conversation to the assignee and let the customer know they will be contacted.",
  "Дружелюбный": "Friendly",
  "Агент продаж": "Sales agent",
  "Квалификация лидов": "Lead qualification",
  "Приветствует потенциальных клиентов, узнаёт их потребности, предлагает подходящие продукты и подключает менеджера, когда клиент готов к разговору.":
    "Greets prospects, learns their needs, suggests suitable products and brings in a manager when the customer is ready to talk.",
  "Познакомиться с клиентом, выяснить задачу и довести до заявки или звонка менеджера.": "Get to know the customer, clarify the task and lead them to a request or a manager call.",
  "Задайте 2–3 уточняющих вопроса о задаче и размере команды, предложите подходящий тариф и предложите демонстрацию. Не называйте цены, которых нет в источниках знаний.":
    "Ask 2–3 clarifying questions about the task and team size, suggest a suitable plan and offer a demo. Do not quote prices that are not in the knowledge sources.",
  "Деловой": "Professional",
  "Агент поддержки": "Support agent",
  "Ответы по продукту": "Product answers",
  "Отвечает на вопросы по продукту с помощью источников знаний AI и плавно передаёт диалог человеку, когда нужен специалист.":
    "Answers product questions using AI knowledge sources and smoothly hands the conversation to a person when a specialist is needed.",
  "Решить типовой вопрос клиента по продукту, не теряя контекста диалога.": "Resolve a typical product question without losing the conversation context.",
  "Отвечайте только по источникам знаний. Если ответа нет или клиент просит человека — передайте диалог специалисту и опишите суть вопроса в заметке.":
    "Answer only from knowledge sources. If there is no answer or the customer asks for a person, hand the conversation to a specialist and summarise the question in a note.",
  "Экспертный": "Expert",
  "Короткий и по делу": "Short and to the point",
  "Анна — приём обращений": "Anna — intake",
  "Здоровайтесь по имени клиента, уточните город и задачу, зафиксируйте телефон и почту. Если вопрос вне вашей компетенции — передайте диалог ответственному.":
    "Greet the customer by name, ask for their city and task, record phone and email. If the question is outside your scope, hand the conversation to the assignee.",
  "Лев — квалификация лидов": "Lev — lead qualification",
  "Задайте 2–3 уточняющих вопроса о задаче и размере команды, предложите подходящий тариф и предложите демонстрацию.":
    "Ask 2–3 clarifying questions about the task and team size, suggest a suitable plan and offer a demo.",
  "Мира — поддержка": "Mira — support",
  "Отвечайте только по источникам знаний. Если ответа нет или клиент просит человека — передайте диалог специалисту.":
    "Answer only from knowledge sources. If there is no answer or the customer asks for a person, hand the conversation to a specialist.",
  "Что агент делает сам": "What the agent does on its own",
  "Отвечает по источникам знаний, задаёт уточняющие вопросы, ставит теги и двигает этап жизненного цикла.":
    "Answers from knowledge sources, asks clarifying questions, adds tags and moves the lifecycle stage.",
  "Когда подключается человек": "When a person steps in",
  "Передача срабатывает по вашим правилам: клиент просит человека, вопрос вне источников или разговор слишком сложный.":
    "Handover follows your rules: the customer asks for a person, the question is outside the sources, or the conversation is too complex.",
  "Как читать цифры": "How to read the numbers",
  "«Диалогов» — сколько разговоров агент взял, «решено» — сколько закрыл без передачи сотруднику.":
    "“Conversations” is how many the agent took on; “resolved” is how many it closed without handing over to an employee.",

  // ── AI Assist: интерфейс ──
  "настройки → входящие → AI Assist": "settings → inbox → AI Assist",
  "AI Assist включён": "AI Assist is on",
  "AI Assist и источники знаний настраивает администратор. Продавцы получают готовые ответы и проверяют их перед отправкой.":
    "AI Assist and knowledge sources are set up by an admin. Salespeople get ready-made replies and review them before sending.",
  "Мгновенные ответы на основе источников знаний вашей компании.": "Instant replies based on your company’s knowledge sources.",
  "Демо-режим: подробная справка по AI Assist в макете недоступна": "Demo mode: detailed help on AI Assist is not available in the mockup",
  "Протестировать AI Assist": "Test AI Assist",
  "Ответы вне источников знаний": "Answers outside knowledge sources",
  "Если включено, ассистент отвечает по общим знаниям модели, как ChatGPT. Выключите — и он будет отвечать только по вашим документам.":
    "When on, the assistant answers from the model’s general knowledge, like ChatGPT. Turn it off and it will answer only from your documents.",
  "Использовать шаблоны как источник": "Use snippets as a source",
  "Все сохранённые ответы становятся источником знаний: сейчас их {n}. Ассистент подставит их дословно.":
    "All saved replies become a knowledge source: there are {n} now. The assistant will insert them verbatim.",
  "Персона AI Assist": "AI Assist persona",
  "Ассистент использует эту персону, чтобы отвечать голосом бренда, опираясь на источники знаний.":
    "The assistant uses this persona to reply in your brand voice, drawing on knowledge sources.",
  "Формулировка персоны сброшена к стандартной": "Persona text reset to the default",
  "Сбросить": "Reset",
  "Текст персоны AI Assist": "AI Assist persona text",
  "есть несохранённые изменения": "unsaved changes",
  "сохранено": "saved",
  "Персона сохранена — ассистент будет отвечать в этом тоне": "Persona saved — the assistant will reply in this tone",
  "Сохранить персону": "Save persona",
  "Как это в диалоге": "How it looks in a conversation",
  "ОС": "OS",
  "Ольга Соколова": "Olga Sokolova",
  "Здравствуйте! Сколько стоит тариф для команды из 12 человек?": "Hello! How much is the plan for a team of 12?",
  "Для 12 человек — 17 880 ₽ в месяц по тарифу «Команда». При оплате за год скидка 20%: 171 648 ₽ за год. Собрать расчёт?":
    "For 12 people it is 17,880 ₽ per month on the Team plan. Pay yearly for a 20% discount: 171,648 ₽ per year. Shall I prepare a quote?",
  "Ответ вставлен в поле сообщения — его можно поправить перед отправкой": "The reply has been inserted into the message box — you can edit it before sending",
  "Вставить": "Insert",
  "Демо-режим: ответ можно отредактировать в настоящем окне Hub": "Demo mode: the reply can be edited in the real Hub window",
  "Изменить": "Edit",
  "Загрузите документы и ссылки в": "Upload documents and links to",
  "источниках знаний": "knowledge sources",
  ", чтобы AI Assist отвечал точно и по вашей компании.": " so AI Assist answers accurately and about your company.",
  "Демо-режим: настройки меняются только в макете — настоящие ответы клиентам не отправляются.":
    "Demo mode: settings change only in the mockup — no real replies are sent to customers.",
  "Тест AI Assist": "AI Assist test",
  "Шаблоны подключены · {n}": "Snippets on · {n}",
  "Шаблоны отключены": "Snippets off",
  "общие знания включены": "general knowledge on",
  "только источники знаний": "knowledge sources only",
  "Закрыть тест AI Assist": "Close AI Assist test",
  "Ответ не из источников знаний — проверьте перед отправкой.": "This reply is not from knowledge sources — check it before sending.",
  "AI Assist печатает…": "AI Assist is typing…",
  "Вопрос для AI Assist": "Question for AI Assist",
  "Спросите про тариф, оплату или подключение…": "Ask about plans, payment or setup…",
  "Отправить вопрос": "Send question",
  "Спросить": "Ask",
  "Открыли источники знаний — туда загружаются документы, ссылки и инструкции": "Opened knowledge sources — upload documents, links and instructions there",
  "Приветствие": "Greeting",
  "Здравствуйте! Я AI Assist. Спросите что угодно о тарифах, оплате или подключении — я отвечу по источникам знаний вашей компании.":
    "Hello! I am AI Assist. Ask me anything about plans, payment or setup — I will answer from your company’s knowledge sources.",
  "Тариф «Команда» — 1 490 ₽ за пользователя в месяц, при оплате за год скидка 20%. Могу собрать расчёт под вашу команду: подскажите, сколько человек будет работать в Hub.":
    "The Team plan is 1,490 ₽ per user per month, with a 20% discount for yearly payment. I can prepare a quote for your team: how many people will work in Hub?",
  "Шаблон «Прайс и условия»": "Snippet “Prices and terms”",
  "Счёт готов и приложен к сообщению: оплатить можно по ссылке из документа, назначение платежа менять не нужно. После оплаты пришлите платёжное поручение — сразу закроем доступ.":
    "The invoice is ready and attached: you can pay via the link in the document, no need to change the payment reference. Send the payment confirmation afterwards and we will open access right away.",
  "Шаблон «Реквизиты для оплаты»": "Snippet “Payment details”",
  "Номер WhatsApp подключается по QR-коду за 2–3 минуты, Telegram — по токену бота. Если нужна помощь с настройкой, инженер подключится к созвону в течение рабочего дня.":
    "A WhatsApp number connects via QR code in 2–3 minutes, Telegram via a bot token. If you need help with setup, an engineer will join a call within one business day.",
  "Шаблон «Сроки подключения»": "Snippet “Setup timeline”",
  "Возврат оформляем в течение 14 дней с момента оплаты: напишите номер договора и причину, мы вышлем форму заявления и вернём деньги на тот же счёт.":
    "Refunds are processed within 14 days of payment: send your contract number and reason, we will send a request form and refund to the same account.",
  "Источник: регламент возвратов": "Source: refund policy",
  "Шаблоны сейчас не используются как источник знаний, поэтому ответ собран по общим знаниям модели. Включите «Использовать шаблоны», чтобы ассистент опирался на сохранённые ответы.":
    "Snippets are currently not used as a knowledge source, so this reply is based on the model’s general knowledge. Turn on “Use snippets” so the assistant relies on saved replies.",
  "Общие знания": "General knowledge",
  "В источниках знаний нет точного ответа, поэтому ассистент ответил по общим знаниям модели. Проверьте формулировку перед отправкой клиенту.":
    "The knowledge sources have no exact answer, so the assistant replied from the model’s general knowledge. Check the wording before sending it to the customer.",
  "В загруженных источниках знаний нет ответа на этот вопрос. Добавьте документ, ссылку или текст-инструкцию — и ассистент сможет отвечать по ним.":
    "The uploaded knowledge sources have no answer to this question. Add a document, a link or a text guide and the assistant will be able to answer from them.",
  "Нет источника": "No source",

  // ── AI Assist: моки ──
  "Рабочее пространство": "Workspace",
  "Общие сведения": "General",
  "Настройки пользователей": "User settings",
  "Настройки команды": "Team settings",
  "Старт": "Start",
  "Приложения": "Apps",
  "Интеграции": "Integrations",
  "Настройки входящих": "Inbox settings",
  "Поля контактов": "Contact fields",
  "Диалоги": "Conversations",
  "Звонки": "Calls",
  "Новое": "New",
  "Данные": "Data",
  "Файлы": "Files",
  "Импорт контактов": "Import contacts",
  "Экспорт данных": "Export data",
  "Вы — опытный агент поддержки Hub. Отвечайте коротко, вежливо и только по делу, опираясь на источники знаний и шаблоны ответов. Всегда проверяйте точность ответа перед отправкой и не придумывайте цены, сроки и условия, которых нет в источниках.":
    "You are an experienced Hub support agent. Reply briefly, politely and to the point, drawing on knowledge sources and reply snippets. Always check the accuracy of your answer before sending and never invent prices, timelines or terms that are not in the sources.",
  "Документ": "Document",
  "PDF, DOCX или TXT до 20 МБ": "PDF, DOCX or TXT up to 20 MB",
  "Ссылка": "Link",
  "Страница сайта, база знаний или Notion": "Website page, knowledge base or Notion",
  "Текст-инструкция": "Text guide",
  "Скрипт или правило, вставленное вручную": "A script or rule pasted manually",
  "REST API: адрес эндпоинта, токен доступа и автообновление": "REST API: endpoint URL, access token and auto-refresh",
  "Документы": "Documents",
  "Прайсы, регламенты и инструкции в PDF, DOCX или TXT — до 20 МБ на файл.": "Price lists, policies and guides in PDF, DOCX or TXT — up to 20 MB per file.",
  "Ссылки": "Links",
  "Страницы сайта, база знаний или Notion: ассистент прочитает их и перескажет клиенту.": "Website pages, a knowledge base or Notion: the assistant will read them and relay them to the customer.",
  "Тексты": "Texts",
  "Скрипты и правила, вставленные вручную — когда готового документа ещё нет.": "Scripts and rules pasted manually — when there is no ready document yet.",
  "Подключите свой сервис по адресу и токену — база знаний будет обновляться сама.": "Connect your service by URL and token — the knowledge base will update itself.",

  // ── Рассылки: интерфейс ──
  "рабочее пространство → рассылки": "workspace → broadcasts",
  "Рассылок: {n}": "Broadcasts: {n}",
  "Найти рассылку": "Find a broadcast",
  "Папка": "Folder",
  "Девять рассылок во всех статусах": "Nine broadcasts in every status",
  "Включите, чтобы увидеть список и календарь": "Turn on to see the list and calendar",
  "Поиск по названию или метке": "Search by name or label",
  "Поиск рассылок": "Search broadcasts",
  "Вид списка": "List view",
  "Таблица": "Table",
  "Календарь": "Calendar",
  "Добавить рассылку": "Add broadcast",
  "Шаблоны рассылок": "Broadcast templates",
  "Импорт рассылок": "Import broadcasts",
  "Экспорт списка": "Export list",
  "«{label}» в демо-режиме недоступен": "“{label}” is not available in demo mode",
  "По запросу «{query}» ничего не нашлось": "Nothing found for “{query}”",
  "В папке «{folder}» пока пусто": "The “{folder}” folder is empty",
  "Попробуйте другое название или очистите поиск — рассылки ищутся и по меткам.": "Try another name or clear the search — broadcasts are also searched by label.",
  "Демо-режим: статья о рассылках в макете недоступна": "Demo mode: the broadcasts article is not available in the mockup",
  "Включить демо-данные и посмотреть, как это выглядит с рассылками": "Turn on demo data to see how it looks with broadcasts",
  "Всего рассылок: {total} · получателей в базе: {audience}. Демо-режим: данные живут только на этой странице.":
    "Total broadcasts: {total} · recipients in the database: {audience}. Demo mode: data lives only on this page.",
  "Демо-режим: рассылки и календарь живут только на этой странице и не сохраняются после перезагрузки.":
    "Demo mode: broadcasts and the calendar live only on this page and are not saved after a reload.",
  "Демо-режим: подробная статья о рассылках в макете недоступна": "Demo mode: the detailed broadcasts article is not available in the mockup",
  "Черновик «{name}» создан — дальше выберите текст, аудиторию и каналы": "Draft “{name}” created — next, choose the text, audience and channels",
  "Демо-данные включены: в окне девять рассылок во всех статусах": "Demo data on: the window shows nine broadcasts in every status",
  "Демо-данные выключены — окно снова пустое": "Demo data off — the window is empty again",
  "Дата отправки": "Send date",
  "аудитория не выбрана": "no audience selected",
  "каналы не выбраны": "no channels selected",
  "без меток": "no labels",
  "Демо-режим: отправка не выполняется": "Demo mode: nothing is actually sent",

  // ── Рассылки: панель ──
  "Новая рассылка": "New broadcast",
  "Название рассылки": "Broadcast name",
  "Название видно только внутри рабочего пространства": "The name is visible only inside the workspace",
  "Введите название — от 2 символов": "Enter a name — at least 2 characters",
  "(необязательно)": "(optional)",
  "Метки помогают находить рассылки в списке и фильтровать их": "Labels help you find and filter broadcasts in the list",
  "Добавить метки к рассылке": "Add labels to the broadcast",
  "Убрать метку {label}": "Remove label {label}",
  "Метки можно поменять в любой момент — в черновике или после отправки.": "Labels can be changed at any time — in the draft or after sending.",

  // ── Рассылки: таблица и календарь ──
  "Без меток": "No labels",
  "{n} по текущему фильтру": "{n} in the current filter",
  "Предыдущий месяц": "Previous month",
  "Следующий месяц": "Next month",
  "Январь": "January",
  "Февраль": "February",
  "Март": "March",
  "Апрель": "April",
  "Май": "May",
  "Июнь": "June",
  "Июль": "July",
  "Август": "August",
  "Сентябрь": "September",
  "Октябрь": "October",
  "Ноябрь": "November",
  "Декабрь": "December",
  "Пн": "Mon",
  "Вт": "Tue",
  "Ср": "Wed",
  "Чт": "Thu",
  "Пт": "Fri",
  "Сб": "Sat",
  "Вс": "Sun",

  // ── Рассылки: моки ──
  "Черновик": "Draft",
  "Запланировано": "Scheduled",
  "Отправляется": "Sending",
  "Завершено": "Completed",
  "Ошибка": "Error",
  "Новости продукта": "Product news",
  "Акции и скидки": "Deals and discounts",
  "Онбординг": "Onboarding",
  "VIP-клиенты": "VIP customers",
  "Возврат клиентов": "Win-back",
  "Обновления тарифа": "Plan updates",
  "Вы ещё не создали ни одной рассылки": "You have not created any broadcasts yet",
  "Рассылка отправляет одно сообщение сразу во множество диалогов — по меткам, этапам жизненного цикла или выбранным вручную контактам.":
    "A broadcast sends one message to many conversations at once — by labels, lifecycle stages or manually selected contacts.",
  "Все рассылки рабочего пространства: черновики, запланированные и уже отправленные.": "All workspace broadcasts: drafts, scheduled and already sent.",
  "Черновики, которые ещё не отправлены: текст, метки и аудиторию можно менять в любой момент.": "Drafts not yet sent: text, labels and audience can be changed at any time.",
  "Рассылки с датой в будущем — уйдут автоматически в выбранное время.": "Broadcasts with a future date — they will go out automatically at the chosen time.",
  "Рассылки, которые прямо сейчас отправляются получателям.": "Broadcasts being sent to recipients right now.",
  "Завершённые рассылки с итоговой статистикой доставки и ответов.": "Completed broadcasts with final delivery and reply stats.",
  "Рассылки, которые не удалось отправить: проверьте каналы и повторите попытку.": "Broadcasts that failed to send: check the channels and try again.",
  "Кому уходит рассылка": "Who receives the broadcast",
  "Получателей выбирают по меткам, этапу жизненного цикла или вручную — можно исключить тех, кто уже ответил.":
    "Recipients are picked by labels, lifecycle stage or manually — you can exclude those who have already replied.",
  "Когда отправлять": "When to send",
  "Рассылка уходит сразу или по расписанию: в календаре видно, в какой день и час она стартует.":
    "A broadcast goes out immediately or on a schedule: the calendar shows the day and hour it starts.",
  "Что показывает статус": "What the status means",
  "«Отправляется» — идёт рассылка, «Завершено» — все сообщения доставлены, «Ошибка» — канал отклонил часть отправок.":
    "“Sending” — the broadcast is in progress, “Completed” — all messages delivered, “Error” — the channel rejected some sends.",
  "Чёрная пятница: подборка тарифов": "Black Friday: plan picks",
  "Мария Петрова": "Maria Petrova",
  "Ноябрьские обновления Hub": "Hub November updates",
  "Алексей Ким": "Alexey Kim",
  "Онбординг новых клиентов — неделя 1": "New customer onboarding — week 1",
  "Ольга Смирнова": "Olga Smirnova",
  "Возврат клиентов, молчавших 3 месяца": "Win back customers silent for 3 months",
  "Дмитрий Волков": "Dmitry Volkov",
  "VIP-клиентам: личный менеджер": "VIP customers: personal manager",
  "Ирина Соколова": "Irina Sokolova",
  "Вебинар «Единые входящие за вечер»": "Webinar “Unified inbox in one evening”",
  "Смена тарифа Growth — предупреждение": "Growth plan change — notice",
  "Скидка 15% на второй номер": "15% off a second number",
  "Проверка канала Telegram перед запуском": "Telegram channel check before launch",

  // ── Почта: интерфейс ──
  "настройки → каналы → почта": "settings → channels → email",
  "Ящиков подключено {n} из {total}": "Mailboxes connected: {n} of {total}",
  "Почтовые ящики": "Mailboxes",
  "Пока ни одного ящика. Выберите провайдера справа — подключение займёт минуту.": "No mailboxes yet. Pick a provider on the right — connecting takes a minute.",
  "Отключить ящик {account}": "Disconnect mailbox {account}",
  "Активен": "Active",
  "новых писем": "new email|new emails",
  "новых писем нет": "no new emails",
  "Ящиков на тарифе": "Mailboxes on plan",
  "Каждый ящик — отдельный поток писем во «Входящих».": "Each mailbox is a separate email stream in the Inbox.",
  "Пароли приложений видит только администратор. Продавцы получают письма, а не доступ к ящику.": "Only admins see app passwords. Salespeople receive emails, not mailbox access.",
  "Поиск по почтовым провайдерам": "Search email providers",
  "Найти провайдера: Gmail, Яндекс, Outlook…": "Find a provider: Gmail, Yandex, Outlook…",
  "Подключено": "Connected",
  "Не подключён": "Not connected",
  "Отключить": "Disconnect",
  "Подключить": "Connect",
  "Провайдер не найден. Попробуйте другое название или категорию.": "Provider not found. Try another name or category.",
  "Письма, вложения и цепочки — в одном диалоге": "Emails, attachments and threads in one conversation",
  "Ответ уходит с адреса ящика": "Replies are sent from the mailbox address",
  "Демо-режим: подключение имитируется в макете, реальные ящики не затрагиваются.": "Demo mode: connecting is simulated in the mockup; real mailboxes are not affected.",
  "Закрыть окно подключения почты": "Close the email connection window",
  "IMAP и SMTP": "IMAP and SMTP",
  "Авторизация у провайдера": "Sign in with the provider",
  "Подключить {name}": "Connect {name}",
  "Hub запросит доступ": "Hub will request access",
  "Hub не сможет удалять письма или менять пароль. Отключить доступ можно в любой момент в настройках ящика.":
    "Hub cannot delete emails or change your password. You can revoke access at any time in the mailbox settings.",
  "Адрес почты": "Email address",
  "Пароль приложения": "App password",
  "Пароль или токен": "Password or token",
  "Имя отправителя": "Sender name",
  "Отдел продаж": "Sales team",
  "Сервер IMAP": "IMAP server",
  "Порт IMAP": "IMAP port",
  "Сервер SMTP": "SMTP server",
  "Порт SMTP": "SMTP port",
  "Шифрование": "Encryption",
  "Без шифрования": "No encryption",
  "Для Gmail, Яндекса и Mail.ru нужен пароль приложения, а не пароль от аккаунта. Пароль хранится в зашифрованном виде.":
    "Gmail, Yandex and Mail.ru require an app password, not your account password. The password is stored encrypted.",
  "Проверяем…": "Checking…",
  "Проверить и подключить": "Check and connect",
  "Ждём подтверждения…": "Waiting for confirmation…",
  "Продолжить": "Continue",
  "Проверяем IMAP": "Checking IMAP",
  "Проверяем SMTP": "Checking SMTP",
  "Отправляем тестовое письмо": "Sending a test email",
  "{name}: ящик {account} подключён — новые письма идут во «Входящие»": "{name}: mailbox {account} connected — new emails go to the Inbox",
  "{name}: ящик отключён, история писем сохранена в архиве": "{name}: mailbox disconnected, email history kept in the archive",

  // ── Почта: моки ──
  "Все провайдеры": "All providers",
  "Корпоративные": "Business",
  "Личные": "Personal",
  "Свой сервер": "Own server",
  "Почта на домене компании: письма клиентов и коллег попадают в общую ленту Hub.": "Email on your company domain: messages from customers and colleagues land in the shared Hub feed.",
  "Популярный": "Popular",
  "Открыть Google": "Open Google",
  "Читать входящие и отправленные письма": "Read incoming and sent emails",
  "Отправлять ответы от имени ящика": "Send replies on behalf of the mailbox",
  "Видеть адрес и имя отправителя": "See the sender’s address and name",
  "Личный или рабочий ящик Gmail: переписка с клиентами рядом с WhatsApp и Telegram.": "A personal or work Gmail account: customer emails next to WhatsApp and Telegram.",
  "Яндекс Почта": "Yandex Mail",
  "Ящик на Яндексе для бизнеса: серверы уже прописаны, нужен только пароль приложения.": "A Yandex business mailbox: servers are preset, only an app password is needed.",
  "Быстрый старт": "Quick start",
  "Microsoft 365 и Outlook": "Microsoft 365 and Outlook",
  "Рабочая почта Microsoft: общий ящик отдела продаж и отдельные адреса менеджеров.": "Microsoft work email: a shared sales mailbox and individual manager addresses.",
  "Открыть Microsoft": "Open Microsoft",
  "Видеть календарь встреч с клиентом": "See the calendar of customer meetings",
  "Почта Mail.ru с паролем приложения: письма превращаются в диалоги с историей.": "Mail.ru email with an app password: emails become conversations with history.",
  "Другая почта по IMAP": "Other email via IMAP",
  "Свой почтовый сервер, корпоративный домен или хостинг: подключение по IMAP и SMTP.": "Your own mail server, corporate domain or hosting: connect via IMAP and SMTP.",
};
export default d;
